//
//
//
//
//
//
//
//

export default {
    name: 'not-found',
    components: {

    },
    props: {
        showText: {
            type: String,
            default: function() {
                return '抱歉，您所找的数据暂不存在'
            }
        }
    },
    data () {
        return {}
    },
    async created () {

    },
    methods: {
    }
}
